import React from "react"
import style from "./SkipLink.module.scss"

type Props = {
  targetId?: string
  children?: React.ReactNode
}

// Let the browser jump to the content of the page and ensure focus lands on <main>
export function SkipLink({ targetId = "main-content", children = "Vai al contenuto della pagina" }: Props) {
  const onActivate = () => {
    // Using setTimeout avoids preventing default navigation.
    setTimeout(() => {
      const el = document.getElementById(targetId) as HTMLElement | null
      if (el) {
        el.focus()
        window.scrollBy(0, -70) //Menu height
      }
    }, 0)
  }

  return (
    <a href={`#${targetId}`} className={style.skipLink} onClick={onActivate}>
      {children}
    </a>
  )
}
